export default function (value) {
  if (!value) return '';

  const strValue = value.toString();

  return strValue.toUpperCase().replace(' ', '-');
}
